import { render, staticRenderFns } from "./BaseSection.global.vue?vue&type=template&id=1835f44c&"
import script from "./BaseSection.global.vue?vue&type=script&lang=js&"
export * from "./BaseSection.global.vue?vue&type=script&lang=js&"
import style0 from "./BaseSection.global.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports